'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getPackageSelectionTitle = _ref => {
  let {
    translations,
    eligibleShipments,
    selectedShipments,
    packageClaims
  } = _ref;
  const {
    claimsSelectionTitleLine2Package,
    claimsSelectionTitleLine2PackageNoEligibility,
    claimsSelectionTitleLine2PackagePackagesSelected,
    claimsSelectionTitlePackage,
    claimsSelectionTitlePackageNoEligibility,
    claimsSelectionTitlePackagePackagesSelected
  } = translations;
  let title = claimsSelectionTitlePackage;
  let subtitle = claimsSelectionTitleLine2Package;
  if (eligibleShipments.length + selectedShipments.length === 0) {
    title = claimsSelectionTitlePackageNoEligibility;
    subtitle = claimsSelectionTitleLine2PackageNoEligibility;
  } else if (Object.keys(packageClaims).length) {
    title = claimsSelectionTitlePackagePackagesSelected;
    subtitle = claimsSelectionTitleLine2PackagePackagesSelected;
  }
  return {
    title,
    subtitle
  };
};

exports["default"] = getPackageSelectionTitle;
